export const MenuData = [
  {
    title: "ABOUT KUBIG",
    url: "/who-we-are",

    submenu: [
      {
        title: "WHO WE ARE",
        url: "/who-we-are",
      },
      {
        title: "PROFESSOR",
        url: "/professor",
      },
    ],
  },
  {
    title: "MEMBERS",
    url: "/members",

    submenu: [
      {
        title: "MEMBERS",
        url: "/members",
      },
      {
        title: "ADMINISTRATOR",
        url: "/organization",
      },
    ],
  },
  {
    title: "STUDIES",

    url: "/studies?difficulty=basic",

    submenu: [
      {
        title: "BASIC",
        url: "/studies?difficulty=basic",
      },
      {
        title: "ADVANCED",
        url: "/studies?difficulty=advance",
      },
      {
        title: "KUBIG MAGAZINE",
        url: "/studies?difficulty=magazine",
      },
    ],
  },
  {
    title: "PROJECTS",
    url: "/projects?category=conference",

    submenu: [
      {
        title: "CONFERENCE",
        url: "/projects?category=conference",
      },
      {
        title: "CONTEST",
        url: "/projects?category=contest",
      },
    ],
  },
  {
    title: "EXTRA CURRICULAR",
    url: "/extra/partnership",

    submenu: [
      {
        title: "PARTNERSHIP",
        url: "/extra/partnership",
      },
      {
        title: "COLLABORATION",
        url: "/extra/collaboration",
      },
      {
        title: "SESSION",
        url: "/extra/session",
      },

      {
        title: "AWARDS",
        url: "/extra/awards",
      },
    ],
  },
  {
    title: "RECRUITING",
    url: "/recruiting",
    submenu: [
      {
        title: "RECRUITING",
        url: "/recruiting",
      },
      {
        title: "FAQ",
        url: "/recruiting/faq",
      },
      {
        title: "NOTICE",
        url: "/recruiting/notice",
      },
    ],
  },
  {
    title: "FOR KUBIG",
    url: "/for-kubig/notice",
  },
];
